import Plot from "react-plotly.js";
import { Button, Icon } from "semantic-ui-react";

// Paleta sóbria
const CORES = ["#37536d", "#4183c4", "#41c4c4", "#21ba45", "#767676", "#ee5a6f", "#f5a623", "#7ed321"];

function GraficoProcessosPorRegional({ dados, onExpandir }) {
  const dadosTratados = (dados || []).map((item) => ({
    label: item.label?.trim() || 'Sem regional',
    valor: item.valor,
  }));

  const labels = dadosTratados.map((item) => item.label);
  const values = dadosTratados.map((item) => item.valor);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <div />
        {onExpandir && (
          <Button 
            icon 
            size="mini" 
            basic 
            onClick={() => onExpandir(dadosTratados, 'Por Regional')}
            title="Ver todas as regionais"
          >
            <Icon name="expand" />
          </Button>
        )}
      </div>
      <Plot
        data={[
          {
            type: "pie",
            values: values,
            labels: labels,
            marker: { colors: CORES },
            textposition: "auto",
            textinfo: "percent+value",
            hoverinfo: "label+value+percent",
          },
        ]}
        config={{
          responsive: true,
          staticPlot: true,
          displayModeBar: false,
        }}
        useResizeHandler={true}
        style={{ width: "100%", height: "280px" }}
        layout={{
          title: {
            text: "<b>POR REGIONAL</b>",
            font: {
              family: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
              size: 14,
              color: "#37536d",
            },
          },
          showlegend: true,
          legend: { 
            orientation: "h", 
            y: -0.2,
            x: 0.5,
            xanchor: "center",
            font: { size: 10 } 
          },
          margin: { t: 40, b: 70, l: 20, r: 20 },
        }}
      />
    </div>
  );
}

export default GraficoProcessosPorRegional;
